import request from '@/utils/request'

export function pageCoupon(query) {
  return request({
    url: '/biz/giftcard/coupon/page',
    method: 'get',
    params: query
  })
}

export function saveCoupon(data) {
  return request({
    url: '/biz/giftcard/coupon/save',
    method: 'post',
    data
  })
}

export function deleteCoupon(id) {
  return request({
    url: '/biz/giftcard/coupon/delete',
    method: 'post',
    params: { id }
  })
}
